import React,{useState,useEffect,useCallback} from 'react'

//redux stuff
import { useSelector, useDispatch} from 'react-redux';
import {setRallyNumber,incrementRallyNumber,setQuestionAnswered,setBestRally,setFlameOn} from "./redux/rallyTracker"


function AnswerScreen(props) {
     
     //random responses
     const goodResponseArray = ['Good Job','Way to go',"You're a genius",'Good for you','Keep Going!','WOW'];
     const badResponseArray = ['you idiot','nice job, stupid',"give up, loser",'you suck','kill yourself','nice try shitbag'];
     var random = Math.floor(Math.random() * goodResponseArray.length);
     const [goodResponse,setGoodResponse] = useState();
     const [badResponse,setBadResponse] = useState();



     const reduxRallyNumber = useSelector((state) => state.rallyTracker.reduxRallyNumber);
     const reduxBestRally = useSelector((state) => state.rallyTracker.reduxBestRally);
     const reduxFlameOn = useSelector((state) => state.rallyTracker.reduxFlameOn);

     //start these off true bc the HTML wont even render unless the answerScreenOpen var is true
     //answerScreenOpen exists to prevent this screen rendering at the start of the app or when the various sections (noun, verb) are expanded
     const [answerScreenOpen,setAnswerScreenOpen] = useState(true);
     var success = "not TrueNorFalse";
     
     //redux
     let dispatch = useDispatch();


     if(props.readyToOpen){
          
          if(props.userInput.trim().toLowerCase() == props.answer.trim().toLowerCase()  ){
               //console.log("correct");
               success = true;
 
          }
          else{
               //console.log("incorrect"); 
               success = false;
          }
     }



     useEffect(() => {
          //we cant put this in the above "if(props.readyToOpen)" bc an infinite loop
          //previously we had the flameOn effect fire after you close the success screen. Which isnt as good as firing upon correct answer
          if(success == true){
               dispatch(incrementRallyNumber());
               dispatch( setFlameOn(true) );
               setTimeout(function(){
                    //after a second, turn the flame off. should be a short, quick thing
                    dispatch( setFlameOn(false) );
               },2000);
               setGoodResponse(goodResponseArray[random]);
          }
          else if(success == false){
               dispatch(setRallyNumber(0));
               setBadResponse(badResponseArray[random]);
          }

     }, [success])





     function fadeOutScreen(answer){
          //set this true, that a question has been answered. Once this redux value is true, ONE useEffect
          //shared by all files will update the DB everytime the "reduxRallyNumber" is changed
          //but we dont want to do it on load
          dispatch( setQuestionAnswered(true) );
          success = "fuck React";
          setAnswerScreenOpen(false);
          setTimeout(function(){
               //use setTimeout() bc theres no other place to reset this to true, so the screen can display again
               //we could do it in the parent compponent but shit is getting crazy
               setAnswerScreenOpen(true);
          },400);
     
     }////fadeOutScreen()


     
     return (
          <div>
               
               {(props.section == 'noun' && props.readyToOpen && success === false) &&
                    <div className={ answerScreenOpen ? 'wrongScreen' : "wrongScreenOFF"}>
                         <div className='center'>
                              <p className='black'>{badResponse}</p>
                              <p> Correct Answer: <span>{props.answer}</span></p>
                              <button onClick={ () => {props.continueAfterError('noun');  fadeOutScreen('wrong')} }>Continue</button>
                         </div>
                    </div>
               }
               {(props.section == 'noun' && props.readyToOpen && success) &&
                    <div className={ answerScreenOpen ? 'successScreen' : "successScreenOFF"}>
                         <div className='center'>
                              <p className='black'>{goodResponse} </p>
                              <p className='correct'> Correct Answer: <span className='correctAnswer'>{props.answer}</span></p>
                              <button onClick={ () => {props.continueAfterError('noun');  fadeOutScreen('correct') }}>Continue</button>
                         </div>
                    </div>
               }




               {(props.section == 'phrase' && props.readyToOpen && success === false) &&
                    <div className={ answerScreenOpen ? 'wrongScreen' : "wrongScreenOFF"}>
                         <div className='center'>
                              <p className='black'>{badResponse}</p>
                              <p> Correct Answer: <span>{props.answer}</span></p>
                              <button onClick={ () => {props.continueAfterError('phrase');  fadeOutScreen('wrong')} }>Continue</button>
                         </div>
                    </div>
               }
               {(props.section == 'phrase' && props.readyToOpen && success) &&
                    <div className={ answerScreenOpen ? 'successScreen' : "successScreenOFF"}>
                         <div className='center'>
                              <p className='black'> {goodResponse} </p>
                              <p className='correct'> Correct Answer: <span className='correctAnswer'>{props.answer}</span></p>
                              <button onClick={ () => {props.continueAfterError('phrase');  fadeOutScreen('correct') }}>Continue</button>
                         </div>
                    </div>
               }


          </div>
     )


}

export default AnswerScreen
